<ng-container *ngFor="let data of dashboardCompetitionsNext">
  <nz-skeleton [nzActive]="true" [nzLoading]="true" *ngIf="data.load" class="py-5 max-sm:py-3"> </nz-skeleton>
  <div *ngIf="!data.load && data.data.length > 0" class="pt-5 max-sm:pt-2">
    <span
      class="bg-red-2 py-1 px-4 rounded-[30px] text-white font-roboto-400 text-15 max-sm:text-11 max-sm:px-2"
    >
      {{ data.date }}
    </span>
    <ng-container *ngIf="data.data && data.data.length > 0">
      <app-scores-football-team
        [dashboardSport]="{
          date: data.dateSearch,
          filter: 'All',
          today: false,
          dashboard: data.data
        }"
        [showScore]="false"
        *ngIf="
          hasFavoriteSport
            ? hasFavoriteSport === 'Futbol' && true
            : menuServices.getSelectedSport() === 'Futbol'
        "
      >
      </app-scores-football-team>
      <app-scores-sports-team
        [dashboardSport]="{
          date: data.dateSearch,
          filter: 'All',
          today: false,
          dashboard: data.data
        }"
        *ngIf="
          hasFavoriteSport
            ? hasFavoriteSport !== 'Futbol' && true
            : menuServices.getSelectedSport() !== 'Futbol'
        "
        [hasFavoriteSport]="hasFavoriteSport"
      ></app-scores-sports-team>
    </ng-container>
    <div
      class="font-roboto-700 text-blue-o-50 my-4 p-4 max-sm:p-3 rounded-6 text-center max-sm:my-2"
      *ngIf="!data.data || (data.data && data.data.length === 0)"
    >
      {{ "NotMatches" | translate }}
    </div>
    <app-no-result
      *ngIf="!data.data || (data.data && data.data.length === 0)"
    ></app-no-result>
  </div>
</ng-container>
